import getConfig from 'next/config';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { APP_SETTINGS, IndexedDb } from 'config/constants';
import dynamic from 'next/dynamic';
import {
  resetStateActionCreator,
  setKeyboardToggleAction,
  toggleOutputBoxEditabilityForMobile,
} from 'src/paraphraser/actions/controlActions';
// import ExtensionContainer from './components/Extension';
// import Paraphraser from './components/Paraphraser';
// import MobileParaphraser from './components/MobileParaphraser';
import { bindActionCreators } from 'redux';
import {
  changedWordFlipper,
  setInputText,
  setStrength,
  // setUploadFileInfo,
  setUserOnboarding,
  setUserOnboardingStep,
} from './actions/paraModelActions';
import { getLocalStorageData } from './actions/paraModelActions';
import QuillLocalStorage from 'core/utils/localStorageClient';
import { paraphraseArticle } from './actions/userParaphrasedAction';
import { setParaphraserDataAction } from 'src/_common/actions/commonActions';
import { QUILL_SETTINGS } from './constants';
import { setTimeout } from 'timers';
import ParaModel from './handlers/ParaModel';
import IndexDbStore from 'core/utils/indexedDbClient';
import QuillSessionStorage from 'core/utils/sessionStorageClient';

const NewModesDialog = dynamic(() => import('src/paraphraser/components/NewModesDialog'), {
  ssr: false,
});

const PremiumDialog = dynamic(() => import('src/paraphraser/components/PremiumDialog'), {
  ssr: false,
});

const ExtensionContainer = dynamic(() => import('./components/Extension'), {
  ssr: true,
});
const Paraphraser = dynamic(() => import('./components/Paraphraser'), {
  ssr: true,
});
const MobileParaphraser = dynamic(() => import('./components/MobileParaphraser'), {
  ssr: true,
});

// const TncDialog = dynamic(() => import('src/paraphraser/components/TncDialog'), {
//   ssr: false,
// });

// const NewThreeBeamsEducationDialog = dynamic(
//   () => import('src/paraphraser/components/ThreebeamsEducationDialog'),
//   {
//     ssr: false,
//   }
// );

const { publicRuntimeConfig } = getConfig();

class HomePageContainer extends Component {
  state = {
    isMobile: this.props?.mode?.isMobile,
    paraphraserComponent: 'loading',
    toggleStateUpdate: false,
  };
  setParaphraserComponent = () => {
    if (window.innerWidth < 600) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
    // handle case when keyboard is opened in Mobile devices
    if (this.props.mode.isMobile) {
      if (window.innerHeight < APP_SETTINGS.INIT_WINDOW_HEIGHT - 50) {
        const klaviyoForms = document.getElementsByClassName(publicRuntimeConfig.KLAVIO_CLASSNAME);
        const activeEl = document.activeElement;
        if (!klaviyoForms || klaviyoForms.length !== 1 || !klaviyoForms[0].contains(activeEl)) {
          this.props.setKeyboardToggleAction(true);
        }
      } else if (
        this.props?.isKeyboardOpen &&
        window.innerHeight >= APP_SETTINGS.INIT_WINDOW_HEIGHT
      ) {
        this.props.toggleOutputBoxEditabilityForMobile(false);
        this.props.setKeyboardToggleAction(false);
      }
    }
  };

  componentDidMount() {
    const otherProductParaphrasedData = QuillSessionStorage.getInstance().get(
      'paraphraserReceivedOtherProductData',
      ''
    );
    QuillSessionStorage.getInstance().delete('paraphraserReceivedOtherProductData');
    if (this.props?.paraphraserReceivedOtherProductData || otherProductParaphrasedData.length) {
      this.props?.dispatch(
        setInputText(this.props?.paraphraserReceivedOtherProductData || otherProductParaphrasedData)
      );
      this.props?.dispatch(paraphraseArticle());
      setTimeout(() => {
        this.props?.dispatch(setParaphraserDataAction(null));
      }, 0);
    }
    const strength = ParaModel.getDefaultStrength();
    this.props?.dispatch(
      getLocalStorageData({
        strength: +strength,
        showLegend: QuillLocalStorage.getInstance().get('showLegend', 'true') === 'true',
        useYellowToHighlightSentence:
          QuillLocalStorage.getInstance().get('useYellowToHighlightSentence', 'false') === 'true',
        showLongestUnchangedWordColor:
          QuillLocalStorage.getInstance().get('showLongestUnchangedWordColor', 'true') === 'true',
        showChangeWordColor:
          QuillLocalStorage.getInstance().get('showChangeWordColor', 'true') === 'true',
        showSentenceRestructureLine:
          QuillLocalStorage.getInstance().get('showSentenceRestructureLine', 'true') === 'true',
        wordFlipperValue: +ParaModel.getDefaultFthresh(strength),
      })
    );
    window.addEventListener('resize', this.setParaphraserComponent);
    this.checkForOnboardingScenario();
    ParaModel.getIndexedDbData();
  }

  checkForOnboardingScenario() {
    if (
      !this.props?.isAuthenticated &&
      QuillLocalStorage.getInstance().get('userOnboardingScenario', 'true') === 'true' &&
      !this.props?.isExtension
    ) {
      this.props?.dispatch(setUserOnboarding(true));
      this.props?.dispatch(
        setUserOnboardingStep(+QuillLocalStorage.getInstance().get('currentUserOnboardingStep', -1))
      );
      return;
    }

    if (this.props?.isAuthenticated && !this.props?.isExtension) {
      this.props?.dispatch(setUserOnboarding(false));
      if (QuillLocalStorage.getInstance().get('submittedInputCount', 0) > 15)
        QuillLocalStorage.getInstance().set('userOnboardingScenario', 'false');
      return;
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps?.isAuthenticated &&
      !this.props?.isAuthenticated &&
      QuillLocalStorage.getInstance().get('userOnboardingScenario', 'true') === 'true' &&
      QuillLocalStorage.getInstance().get('submittedInputCount', 0) <= 15
    )
      this.props?.dispatch(setUserOnboarding(true));

    if (prevProps?.isAuthenticated && !this.props?.isAuthenticated) {
      this.props?.dispatch(
        resetStateActionCreator(() => {
          this.props?.dispatch(setStrength(this.props?.strength === 0 ? 0 : 2));
          this.props?.dispatch(changedWordFlipper(this.props?.strength === 0 ? 0 : 1));
          // QUILL_SETTINGS.fthresh = this.props?.strength === 0 ? 0 : 1;
          QuillLocalStorage?.getInstance().set('fthresh', this.props?.strength === 0 ? 0 : 1);
          QuillLocalStorage?.getInstance().set(
            'prioritize',
            this.props?.strength === 0 ? '0' : '2'
          );
          if (!this.props?.mode?.isIE)
            IndexDbStore?.getInstance()?.clearDataStore(IndexedDb.collections.paraphraseHistory);
          // QuillLocalStorage?.getInstance().deleteMulti([
          //   'historyInputText',
          //   'historyInputSentences',
          //   'historyParaphraser',
          // ]);
        }, true)
      );
    }

    if (prevProps?.regionalLanguage !== this.props?.regionalLanguage) {
      ParaModel.clearBeams('Settings Changed');
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setParaphraserComponent);
    this.props.setKeyboardToggleAction(false);
  }

  checkComponentAccordingToModeState() {
    if (this.props.mode?.isExtension) {
      return <ExtensionContainer />;
    }
    if (!this.state.isMobile) {
      return <Paraphraser />;
    }
    if (this.state.isMobile) {
      return <MobileParaphraser toggleStateUpdate={this.state.toggleStateUpdate} />;
    }
  }

  render() {
    return (
      <div>
        {this.checkComponentAccordingToModeState()}
        {/* {!this.props?.mode?.isExtension && !this.state?.isMobile && (
          <NewThreeBeamsEducationDialog />
        )} */}
        {!this.props?.mode?.isExtension && <PremiumDialog />}
        {/* {this.props?.isPremium && <TncDialog />} */}
        <NewModesDialog />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  isAuthenticated: state?.user?.isAuthenticated,
  isPremium: state?.user?.premium,
  isExtension: state?.common.platform.isExtension,
  mode: state?.common?.platform || {},
  isKeyboardOpen: state?.common?.isKeyboardOpen,
  paraphraserReceivedOtherProductData: state?.common?.paraphraserReceivedOtherProductData,
  strength: state?.pphr?.strength,
  regionalLanguage: state?.common.regionalLanguage,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    ...bindActionCreators(
      {
        setKeyboardToggleAction,
        toggleOutputBoxEditabilityForMobile,
        paraphraseArticle,
        resetStateActionCreator,
      },
      dispatch
    ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HomePageContainer);
